import {
    CustomerGroupResponse
} from '@/modules/configurationModule/detail/accounting/billable/customer-groups/services/customer-groups.dto'

export type CustomerGroupsModalState = CustomerGroupResponse
export const initialCustomerGroupsModalState =
    (): CustomerGroupResponse => ({
        id: -1,
        name: '',
        code: '',
        active: true
    })
